// src/components/profiles/Member/components/posts/moment/MomentEmptyState.tsx

"use client";

import React from "react";
import { BringToFront } from "lucide-react";
import { Button } from "../../../../../common";

import "./MomentEmptyState.css";

interface Props {
    onCreate?: () => void;
}

const MomentEmptyState: React.FC<Props> = ({ onCreate }) => {
    return (
        <div className="moment-empty">
            <div className="moment-empty__icon">
                <BringToFront size={48} />
            </div>

            <h4 className="moment-empty__title">
                Moments are for the little big things
            </h4>

            <p className="moment-empty__text">
                Share meaningful memories — from faith-filled reflections to the beauty
                of everyday life.
            </p>

            {onCreate && (
                <Button
                    variant="primary"
                    size="md"
                    onClick={onCreate}
                >
                    <span className="btn-content">
                        <span>Create your first Moment</span>
                    </span>
                </Button>
            )}

        </div>
    );
};

export default MomentEmptyState;
